import { Button, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { withErrorHandling } from "@entrilia/shared/api/axiosHelper";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import DialogCloseButton from "@entrilia/shared/components/DialogCloseButton";
import SmallDialog from "@entrilia/shared/components/SmallDialog";
import { useNotificationContext } from "@entrilia/shared/contexts/NotificationContext";
import { logError } from "@entrilia/shared/logging";
import adminApi from "../../../../api/adminApi";

interface Props {
  workflowId: string;
  open: boolean;
  onClose: () => void;
  onRetried: () => void;
}

const retryRequest = withErrorHandling(adminApi.retryInvestorChangeRequest);

const RetryConfirmationDialog = ({ workflowId, open, onClose, onRetried }: Props) => {
  const { sendNotification, sendNotificationError } = useNotificationContext();
  const [loading, setLoading] = useState(false);

  const handleRetryClick = async () => {
    setLoading(true);
    const [, error] = await retryRequest({ workflowId });
    setLoading(false);

    if (error) {
      logError(error, "[RetryConfirmationDialog] retryInvestorChangeRequest");
      sendNotificationError(error.message);
      return;
    }

    onClose();
    sendNotification("The request is being applied again");
    onRetried();
  };

  return (
    <SmallDialog open={open} onClose={onClose}>
      <DialogTitle>Retry</DialogTitle>
      <DialogCloseButton onClick={onClose} />
      <DialogContent>
        <Stack spacing={0.5} sx={{ alignItems: "center" }}>
          <Typography variant="h6">Retry request?</Typography>
          <Typography color="textSecondary" sx={{ textAlign: "center" }}>
            The system will attempt to apply the requested changes again. Make sure the issue that caused the failure
            has been resolved.
          </Typography>
        </Stack>
      </DialogContent>
      <DialogButtons onCancel={onClose}>
        <Button variant="contained" loading={loading} onClick={handleRetryClick}>
          Retry
        </Button>
      </DialogButtons>
    </SmallDialog>
  );
};

export default RetryConfirmationDialog;
